<template>
   <div class="features-and-functions-section">
      <PageFrameContainer>
         <h2>{{$t('pages.main.features.title')}}</h2>
         <div class="features">
            <div class="features-animation-container">
               <iframe class="features-animation" ref="features-animation" frameborder="0" scrolling="no"></iframe>
            </div>
            <ul>
               <li v-for="(i,index) in $t('pages.main.features.featuresList')"
                   :key="index">{{i}}
               </li>
            </ul>
         </div>
         <div class="gallery-container">
            <MainPageScreenshotGallery/>
         </div>
         <div class="star-features-container">
            <ul class="star-features">
               <li v-for="(i,index) in $t('pages.main.features.starFeatures')"
                   :key="index">{{i}}
               </li>
            </ul>
         </div>
      </PageFrameContainer>
   </div>

</template>

<script>
    import PageFrameContainer from "../../../components/PageFrameContainer";
    import MainPageScreenshotGallery from "../parts/MainPageScreenshotGallery";

    export default {
        name: "FeaturesAndFunctionsSection",
        components: {MainPageScreenshotGallery,PageFrameContainer},
        async mounted() {
            let featureAnimationFrame = this.$refs['features-animation'];
            let doc = featureAnimationFrame.contentWindow.document;
            let animationContent = await require('../../../assets/pages/main/animations/24-7/OneBlending-24-7.html');
            doc.open().write(animationContent);
            doc.close();
        }
    }
</script>

<style scoped lang="scss">
   @import "../../../theme/theme";

   .features-and-functions-section {
      padding-top: 2em;
      padding-bottom: 3em;
      background: $primary100;

      .gallery-container {
         display: grid;
         justify-items: center;
      }

      .star-features-container {
         margin-top: 1rem;
         display: grid;
         justify-items: center;

         ul.star-features {
            color: $primaryText100;
            display: grid;
            column-gap: 2rem;
            grid-auto-flow: column;

            li {
               list-style-type: none;
            }

            li::before {
               content: "★ ";
            }
         }
      }

      h2 {
         text-align: center;
         color: $primaryText100;
         font-size: 1.6rem;
         font-weight: 300;
         margin-bottom: 1.2em;
      }

      .features-animation-container {
         align-self: center;
         justify-self: center;
         overflow: hidden;

         iframe {
            overflow: hidden;
         }
      }

      .features-animation {
         display: block;
         width: 430px;
         height: 170px;
         border: none;
      }

      .features {
         display: grid;
         justify-items: center;
         grid-gap: 2em;
         overflow-x: hidden;

         ul {
            color: $primaryText100;
            font-size: 1rem;
            font-weight: 300;
            padding: 1em;
         }

         li {
            text-align: justify;
            line-height: 1.5rem;
         }
      }
   }


   @media (max-width: 50em) {
      .features-and-functions-section {
         .features {
            grid-template-rows: auto auto;
            grid-template-columns: 1fr;

            ul {
               max-width: 30em;
            }
         }

         .features-animation-container {
            $percent: 0.25;
            margin-bottom: -170px*$percent;

            .features-animation {
               -ms-transform: scale(1-$percent);
               -moz-transform: scale(1-$percent);
               -o-transform: scale(1-$percent);
               -webkit-transform: scale(1-$percent);
               transform: scale(1-$percent);

               -ms-transform-origin: center;
               -moz-transform-origin: center;
               -o-transform-origin: center;
               -webkit-transform-origin: center;
               transform-origin: center;
            }
         }
      }
   }

   @media (min-width: 50em) {
      .features-and-functions-section .features {
         grid-template-rows: auto;
         grid-template-columns: 1fr 1fr;
      }
   }

</style>